"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormBuilderFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const form_builder_style_1 = require("../form-builder.style");
exports.FormBuilderFooter = (0, react_1.memo)((props) => {
    const { components, contentRef, isStickyFooter } = props;
    const footerRef = (0, react_1.useRef)(null);
    const [isDefaultPosition, setIsDefaultPosition] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const handleScroll = () => {
            if (!footerRef.current || !contentRef.current)
                return;
            const contentBottom = contentRef.current.getBoundingClientRect().bottom;
            const footerBottom = footerRef.current.getBoundingClientRect().bottom;
            setIsDefaultPosition(contentBottom === footerBottom);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    return (!!(components === null || components === void 0 ? void 0 : components.length) && ((0, jsx_runtime_1.jsx)(form_builder_style_1.FooterWrapper, { isSticky: isStickyFooter, isDefaultPosition: isDefaultPosition, ref: footerRef, children: components.map((_a, index) => {
            var { component: Component } = _a, _b = _a.props, { name } = _b, additionalVariables = __rest(_b, ["name"]);
            return ((0, jsx_runtime_1.jsx)(Component, { additionalVariables: additionalVariables }, `${name}-${index}`));
        }) })));
});
exports.FormBuilderFooter.displayName = 'FormBuilderFooter';
